import React                 from "react";
import PropTypes             from "prop-types";
import Translations          from "../../utils/Translations";
import {VXButtonLineConfig}  from "../SimpleElements/VXButton/VXButtonConfig";
import VXButtonOutline       from "../SimpleElements/VXButton/Presets/VXButtonOutline";

class ProfileOverviewVideosBlock extends React.PureComponent {

	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className="media-panel container-block -margin-bottom-lg">
				<div className="context-box--actor-profile clearfix">
					<h2 className="context-box__title h-left" dangerouslySetInnerHTML={{__html: Translations.get('MediaPanelActorLatestVideos')}}/>
				</div>
				<div>
					{this.props.profileOverviewVideos}
				</div>
				<div className="row actor-content-placeholder -all-videos">
					<VXButtonOutline link		= {this.props.buttonLink}
					                 line1 	    = {[new VXButtonLineConfig(Translations.get('AllVideos'))]}
					                 icon	    = {'-icon-double-arrow-right-line'}
									 navigateTo = {this.props.navigateTo}
					/>
				</div>
			</div>
		);
	}

}

ProfileOverviewVideosBlock.propTypes = {
	profileOverviewVideos: PropTypes.element.isRequired,
	buttonLink:            PropTypes.string.isRequired,
	navigateTo:            PropTypes.func,
};

export default ProfileOverviewVideosBlock;